import React from "react";
import { Alert, Typography } from "@mui/material";

const PushInfoAlert = () => (
  <Alert severity="info" sx={{ mb: 3 }}>
    <Typography variant="body2">
      <strong>Push to Database:</strong> Final review before pushing bars to the production database.
      Uncheck any bars you don&apos;t want to include.
    </Typography>
  </Alert>
);

export default PushInfoAlert;
